export const ReviewInstanceStatus = {
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    EXPIRED: 'Expired',
} as const;

export type ReviewInstanceStatusValue =
    (typeof ReviewInstanceStatus)[keyof typeof ReviewInstanceStatus];
